import { render, staticRenderFns } from "./AdminActivities.vue?vue&type=template&id=96311fb2&scoped=true"
import script from "./AdminActivities.vue?vue&type=script&lang=ts"
export * from "./AdminActivities.vue?vue&type=script&lang=ts"
import style0 from "./AdminActivities.vue?vue&type=style&index=0&id=96311fb2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96311fb2",
  null
  
)

export default component.exports